import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=218db215&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=js&"
export * from "./inventory.vue?vue&type=script&lang=js&"
import style0 from "./inventory.vue?vue&type=style&index=0&id=218db215&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218db215",
  null
  
)

export default component.exports